import request from '@/utils/request';
import { datasetEndpoint } from '@/constants/urls';

const metrics = (code) => request({
  url: `${datasetEndpoint(code)}/metrics`,
  method: 'GET',
});

const DatasetMetricsService = {
  metrics,
};

export default DatasetMetricsService;
